import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { QuestionListComponent } from './question-list.component';
import { QuestionEditComponent } from './question-edit/question-edit.component';

@NgModule({
  declarations: [
    QuestionListComponent,
    QuestionEditComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ]
})
export class QuestionListModule {}



// WEBPACK FOOTER //
// ./src/app/question-list/question-list.module.ts